import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { ArrowBackComponent } from '../GlobalComponents/arrow-back.component';
import { videosAdministrador, videosBienesCulturales, videosDocumentosOficiales, videosGestiones, videosReportes, videosSolicitudes, VideoTutorialesInterface } from './videos-list';
import { VideoGridComponent } from './video-grid/video-grid.component';

@Component({
    selector: 'video-tutoriales',
    templateUrl: 'video-tutoriales.component.html',
    imports:[
        CommonModule,
        MatButtonModule,
        MatTabsModule,
        MatIconModule,

        ArrowBackComponent,
        VideoGridComponent,
    ]
})

export class VideoTutorialesComponent implements OnInit {
    videosAdministrador:       VideoTutorialesInterface[] = videosAdministrador
    videosSolicitudes:         VideoTutorialesInterface[] = videosSolicitudes
    videosGestiones:           VideoTutorialesInterface[] = videosGestiones
    videosBienesCulturales:    VideoTutorialesInterface[] = videosBienesCulturales
    videosDocumentosOficiales: VideoTutorialesInterface[] = videosDocumentosOficiales
    videosReportes:            VideoTutorialesInterface[] = videosReportes

    constructor() { }

    ngOnInit() { }

}